import remoteConfigService from '../../helpers/remote-config.service';
import { REMOTE_CONFIG_KEYS } from 'shared/constants';
import { LANGUAGE } from 'shared/constants/lang';
import { LANG_MANAGER_UPDATE_REPO } from 'shared/store/actions';

export const fetchLanguageFromRemoteConfig = () => async dispatch => {
  const remoteRepo = remoteConfigService.getJsonValue(REMOTE_CONFIG_KEYS.LANGUAGE);
  if (!remoteRepo || Object.keys(remoteRepo).length === 0) return;

  const repo = Object.fromEntries(
    Object.entries(LANGUAGE).map(([key, local]) => {
      const remote = remoteRepo[key];
      if (!remote) return [key, local];
      return [key, { ...local, lang: { ...remote.lang, ...local.lang } }];
    }),
  );

  dispatch({
    type: LANG_MANAGER_UPDATE_REPO,
    payload: { repo },
  });
};
